/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Plan_Change_DescriptionInputs */

const fr_membership_plan_change_description = /** @type {(inputs: Membership_Plan_Change_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le changement prendra effet le ${i?.date}, à votre prochaine échéance, sans prorata ni remboursement. Votre formule actuelle reste active jusque-là.`)
};

/**

* @param {Membership_Plan_Change_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_description = /** @type {((inputs: Membership_Plan_Change_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_description(inputs)
});